import { StoreAttributes } from '@pylot-data/hooks/product/graphql/Fragments/StoreAttributes'
import { DefaultCategory } from '@pylot-data/hooks/product/graphql/Fragments/DefaultCategory'
import { onConfigurableProductFragment } from '@pylot-data/hooks/product/graphql/Fragments/onConfigurableProductFragment'

export const onProductUpCrosellFragment = /* GraphQL */ `
  __typename
  id
  uid
  name
  sku
  url_key
  brand
  brand_text
  stock_status
  product_eyebrow_badge
  product_eyebrow_badge_text
  small_image {
    __typename
    url
  }
  short_description {
    html
  }
  thumbnail {
    url
  }
  ${DefaultCategory}
  categories {
      __typename
      name
      url_path
      breadcrumbs {
          __typename
          category_uid
          category_name
          category_url_path
      }
  }
  price_range {
    __typename
    minimum_price {
      __typename
      regular_price {
        __typename
        value
        currency
      }
      final_price {
        __typename
        value
        currency
      }
      discount {
        __typename
        amount_off
      }
    }
    maximum_price {
      __typename
      final_price {
        __typename
        value
        currency
      }
      discount {
        percent_off
      }
    }
  }
  description_title
  subtitle
  addtocart_popup_cms
  ${StoreAttributes}
  ${onConfigurableProductFragment}
#  ... on BundleProduct {
##    is_custom_kit
##    items{
##      ooka_product_option
##    }
#  }
  is_tobacco_product
`
